import { injectable } from 'inversify';
import { DefaultsModel } from '../../models/DefaultsModel';

@injectable()
export abstract class DefaultsModelProvider {
  abstract getDefaultsModel(): Promise<DefaultsModel>;
}
